import React, { useState } from 'react'
import { WinnersDropdown, WinnersHeader } from './style'
import { Winners } from './index'

export const WinnersLayout = (props) => {
    const { winners = [], currentAct, children } = props

    if (!winners.length) return null;

    // const [specId, setSpecId] = useState<any>(Math.floor(Math.random() * winners.length));

    // const options = winners.map((i, id) => ({ key: id, text: i.tabs, value: id }))

    const modifiedWinners = Object.keys(winners).reduce((memo, i) => {
        const w = winners[i]
        return memo.concat(w.winners.map(j => ({ ...j, spec: w.tabs })))
    }, [])

    return (<>
        <WinnersHeader>
            {children}
            {/* {winners.length > 1 && <WinnersDropdown options={options} selection onChange={(e, { value }) => setSpecId(value)} value={specId} upward={false} />} */}
        </WinnersHeader>
        <Winners currentAct={currentAct} winners={modifiedWinners}/>
    </>)
}